// 语文/数学占位页。
import { el, topbar } from "../lib";

export function comingSoonView(root: HTMLElement, subject: string): void {
  document.title = `${subject} · 小朋友学习乐园`;
  root.appendChild(topbar([{ label: subject }]));

  const main = el("main", "wrap main-pad center-col");
  const card = el("div", "soon-card");
  card.appendChild(el("div", "sc-emoji", "🚧"));
  card.appendChild(el("div", "sc-name", `${subject}马上就来`));
  card.appendChild(el("div", "sc-sub", "敬请期待哦～"));
  main.appendChild(card);
  root.appendChild(main);
}
